"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9184],{

/***/ "./node_modules/@chakra-ui/tabs/dist/index.esm.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OK": function() { return /* binding */ Tab; },
/* harmony export */   "mQ": function() { return /* binding */ Tabs; },
/* harmony export */   "nP": function() { return /* binding */ TabPanels; },
/* harmony export */   "td": function() { return /* binding */ TabList; },
/* harmony export */   "x4": function() { return /* binding */ TabPanel; },
/* harmony export */   "xD": function() { return /* binding */ useTab; }
/* harmony export */ });
/* unused harmony exports TabIndicator, TabsDescendantsProvider, TabsProvider, useTabIndicator, useTabList, useTabPanel, useTabPanels, useTabs, useTabsContext, useTabsDescendant, useTabsDescendants, useTabsDescendantsContext, useTabsStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/react-context/dist/index.esm.js");
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./node_modules/@chakra-ui/styled-system/dist/index.esm.js");
/* harmony import */ var _chakra_ui_clickable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/@chakra-ui/clickable/dist/index.esm.js");
/* harmony import */ var _chakra_ui_descendant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@chakra-ui/descendant/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./node_modules/@chakra-ui/react-use-safe-layout-effect/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react_use_controllable_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/react-use-controllable-state/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@chakra-ui/react-children-utils/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./node_modules/@chakra-ui/react-use-merge-refs/dist/index.esm.js");
/* harmony import */ var _chakra_ui_lazy_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./node_modules/@chakra-ui/lazy-utils/dist/index.esm.js");
// ../../../react-shim.js


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}

// src/tab-indicator.tsx


// src/tabs.tsx




// src/use-tabs.ts









var [
  TabsDescendantsProvider,
  useTabsDescendantsContext,
  useTabsDescendants,
  useTabsDescendant
] = (0,_chakra_ui_descendant__WEBPACK_IMPORTED_MODULE_1__/* .createDescendantContext */ .n)();
function useTabs(props) {
  const {
    defaultIndex,
    onChange,
    index,
    isManual,
    isLazy,
    lazyBehavior = "unmount",
    orientation = "horizontal",
    direction = "ltr",
    ...htmlProps
  } = props;
  const [focusedIndex, setFocusedIndex] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultIndex ?? 0);
  const [selectedIndex, setSelectedIndex] = (0,_chakra_ui_react_use_controllable_state__WEBPACK_IMPORTED_MODULE_2__/* .useControllableState */ .T)({
    defaultValue: defaultIndex ?? 0,
    value: index,
    onChange
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (index != null) {
      setFocusedIndex(index);
    }
  }, [index]);
  const descendants = useTabsDescendants();
  const uuid = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
  const uid = props.id ?? uuid;
  const id = `tabs-${uid}`;
  return {
    id,
    selectedIndex,
    focusedIndex,
    setSelectedIndex,
    setFocusedIndex,
    isManual,
    isLazy,
    lazyBehavior,
    orientation,
    descendants,
    direction,
    htmlProps
  };
}
var [TabsProvider, useTabsContext] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_3__/* .createContext */ .k)({
  name: "TabsContext",
  errorMessage: "useTabsContext: `context` is undefined. Seems you forgot to wrap all tabs components within <Tabs />"
});
function useTabList(props) {
  const { focusedIndex, orientation, direction } = useTabsContext();
  const descendants = useTabsDescendantsContext();
  const onKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event) => {
    const nextTab = () => {
      var _a;
      const next = descendants.nextEnabled(focusedIndex);
      if (next)
        (_a = next.node) == null ? void 0 : _a.focus();
    };
    const prevTab = () => {
      var _a;
      const prev = descendants.prevEnabled(focusedIndex);
      if (prev)
        (_a = prev.node) == null ? void 0 : _a.focus();
    };
    const firstTab = () => {
      var _a;
      const first = descendants.firstEnabled();
      if (first)
        (_a = first.node) == null ? void 0 : _a.focus();
    };
    const lastTab = () => {
      var _a;
      const last = descendants.lastEnabled();
      if (last)
        (_a = last.node) == null ? void 0 : _a.focus();
    };
    const isHorizontal = orientation === "horizontal";
    const isVertical = orientation === "vertical";
    const eventKey = event.key;
    const ArrowStart = direction === "ltr" ? "ArrowLeft" : "ArrowRight";
    const ArrowEnd = direction === "ltr" ? "ArrowRight" : "ArrowLeft";
    const keyMap = {
      [ArrowStart]: () => isHorizontal && prevTab(),
      [ArrowEnd]: () => isHorizontal && nextTab(),
      ArrowDown: () => isVertical && nextTab(),
      ArrowUp: () => isVertical && prevTab(),
      Home: firstTab,
      End: lastTab
    };
    const action = keyMap[eventKey];
    if (action) {
      event.preventDefault();
      action(event);
    }
  }, [descendants, focusedIndex, orientation, direction]);
  return {
    ...props,
    role: "tablist",
    "aria-orientation": orientation,
    onKeyDown: callAllHandlers(props.onKeyDown, onKeyDown)
  };
}
function useTab(props) {
  const { isDisabled, isFocusable, ...htmlProps } = props;
  const { setSelectedIndex, isManual, id, setFocusedIndex, selectedIndex } = useTabsContext();
  const { index, register } = useTabsDescendant({
    disabled: isDisabled && !isFocusable
  });
  const isSelected = index === selectedIndex;
  const onClick = () => {
    setSelectedIndex(index);
  };
  const onFocus = () => {
    setFocusedIndex(index);
    const isDisabledButFocusable = isDisabled && isFocusable;
    const shouldSelect = !isManual && !isDisabledButFocusable;
    if (shouldSelect) {
      setSelectedIndex(index);
    }
  };
  const clickableProps = (0,_chakra_ui_clickable__WEBPACK_IMPORTED_MODULE_4__/* .useClickable */ .h)({
    ...htmlProps,
    ref: (0,_chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_5__/* .mergeRefs */ .lq)(register, props.ref),
    isDisabled,
    isFocusable,
    onClick: callAllHandlers(props.onClick, onClick)
  });
  const type = "button";
  return {
    ...clickableProps,
    id: makeTabId(id, index),
    role: "tab",
    tabIndex: isSelected ? 0 : -1,
    type,
    "aria-selected": isSelected,
    "aria-controls": makeTabPanelId(id, index),
    onFocus: isDisabled ? void 0 : callAllHandlers(props.onFocus, onFocus)
  };
}
var [TabPanelProvider, useTabPanelContext] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_3__/* .createContext */ .k)({});
function useTabPanels(props) {
  const context = useTabsContext();
  const { id, selectedIndex } = context;
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_6__/* .getValidChildren */ .W)(props.children);
  const children = validChildren.map((child, index) => (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(TabPanelProvider, {
    key: index,
    value: {
      isSelected: index === selectedIndex,
      id: makeTabPanelId(id, index),
      tabId: makeTabId(id, index),
      selectedIndex
    }
  }, child));
  return { ...props, children };
}
function useTabPanel(props) {
  const { children, ...htmlProps } = props;
  const { isLazy, lazyBehavior } = useTabsContext();
  const { isSelected, id, tabId } = useTabPanelContext();
  const hasBeenSelected = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  if (isSelected) {
    hasBeenSelected.current = true;
  }
  const shouldRenderChildren = (0,_chakra_ui_lazy_utils__WEBPACK_IMPORTED_MODULE_7__/* .lazyDisclosure */ .k)({
    wasSelected: hasBeenSelected.current,
    isSelected,
    enabled: isLazy,
    mode: lazyBehavior
  });
  return {
    tabIndex: 0,
    ...htmlProps,
    children: shouldRenderChildren ? children : null,
    role: "tabpanel",
    "aria-labelledby": tabId,
    hidden: !isSelected,
    id
  };
}
function useTabIndicator() {
  const context = useTabsContext();
  const descendants = useTabsDescendantsContext();
  const { selectedIndex, orientation } = context;
  const isHorizontal = orientation === "horizontal";
  const isVertical = orientation === "vertical";
  const [rect, setRect] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    if (isHorizontal)
      return { left: 0, width: 0 };
    if (isVertical)
      return { top: 0, height: 0 };
    return void 0;
  });
  const [hasMeasured, setHasMeasured] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,_chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_8__/* .useSafeLayoutEffect */ .G)(() => {
    if (selectedIndex == null)
      return;
    const tab = descendants.item(selectedIndex);
    if (tab == null)
      return;
    if (isHorizontal) {
      setRect({ left: tab.node.offsetLeft, width: tab.node.offsetWidth });
    }
    if (isVertical) {
      setRect({ top: tab.node.offsetTop, height: tab.node.offsetHeight });
    }
    const id = requestAnimationFrame(() => {
      setHasMeasured(true);
    });
    return () => {
      if (id) {
        cancelAnimationFrame(id);
      }
    };
  }, [selectedIndex, isHorizontal, isVertical, descendants]);
  return {
    position: "absolute",
    transitionProperty: "left, right, top, bottom, height, width",
    transitionDuration: hasMeasured ? "200ms" : "0ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    ...rect
  };
}
function makeTabId(id, index) {
  return `${id}--tab-${index}`;
}
function makeTabPanelId(id, index) {
  return `${id}--tabpanel-${index}`;
}

// src/tabs.tsx
var [TabsStylesProvider, useTabsStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_3__/* .createContext */ .k)({
  name: `TabsStylesContext`,
  errorMessage: `useTabsStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Tabs />" `
});
var Tabs = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_9__/* .forwardRef */ .Gp)(function Tabs2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_9__/* .useMultiStyleConfig */ .jC)("Tabs", props);
  const { children, className, ...rest } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_10__/* .omitThemingProps */ .Lr)(props);
  const { htmlProps, descendants, ...ctx } = useTabs(rest);
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ctx, [ctx]);
  const { isFitted: _, ...rootProps } = htmlProps;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TabsDescendantsProvider, {
    value: descendants
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TabsProvider, {
    value: context
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TabsStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_9__/* .chakra.div */ .m$.div, {
    className: cx("chakra-tabs", className),
    ref,
    ...rootProps,
    __css: styles.root
  }, children))));
});
Tabs.displayName = "Tabs";

// src/tab-indicator.tsx
var TabIndicator = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_9__/* .forwardRef */ .Gp)(function TabIndicator2(props, ref) {
  const indicatorStyle = useTabIndicator();
  const style = {
    ...props.style,
    ...indicatorStyle
  };
  const styles = useTabsStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_9__/* .chakra.div */ .m$.div, {
    ref,
    ...props,
    className: cx("chakra-tabs__tab-indicator", props.className),
    style,
    __css: styles.indicator
  });
});
TabIndicator.displayName = "TabIndicator";

// src/tab-list.tsx

var TabList = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_9__/* .forwardRef */ .Gp)(function TabList2(props, ref) {
  const tablistProps = useTabList({ ...props, ref });
  const styles = useTabsStyles();
  const tablistStyles = {
    display: "flex",
    ...styles.tablist
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_9__/* .chakra.div */ .m$.div, {
    ...tablistProps,
    className: cx("chakra-tabs__tablist", props.className),
    __css: tablistStyles
  });
});
TabList.displayName = "TabList";

// src/tab-panel.tsx

var TabPanel = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_9__/* .forwardRef */ .Gp)(function TabPanel2(props, ref) {
  const panelProps = useTabPanel({ ...props, ref });
  const styles = useTabsStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_9__/* .chakra.div */ .m$.div, {
    outline: "0",
    ...panelProps,
    className: cx("chakra-tabs__tab-panel", props.className),
    __css: styles.tabpanel
  });
});
TabPanel.displayName = "TabPanel";

// src/tab-panels.tsx

var TabPanels = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_9__/* .forwardRef */ .Gp)(function TabPanels2(props, ref) {
  const panelsProps = useTabPanels(props);
  const styles = useTabsStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_9__/* .chakra.div */ .m$.div, {
    ...panelsProps,
    width: "100%",
    ref,
    className: cx("chakra-tabs__tab-panels", props.className),
    __css: styles.tabpanels
  });
});
TabPanels.displayName = "TabPanels";

// src/tab.tsx

var Tab = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_9__/* .forwardRef */ .Gp)(function Tab2(props, ref) {
  const styles = useTabsStyles();
  const tabProps = useTab({ ...props, ref });
  const tabStyles = {
    outline: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...styles.tab
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_9__/* .chakra.button */ .m$.button, {
    ...tabProps,
    className: cx("chakra-tabs__tab", props.className),
    __css: tabStyles
  });
});
Tab.displayName = "Tab";



/***/ }),

/***/ "./src/components/Elements/EditorRank/EditorRank.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");




const RankIcon = (param)=>{
    let { rank , size  } = param;
    switch(rank){
        case 0:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5, {
                color: "#DD6B20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_3__/* .RiTrophyFill */ .e6w, {
                    fontSize: size
                })
            });
        case 1:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5, {
                color: "#D69E2E",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_3__/* .RiTrophyFill */ .e6w, {
                    fontSize: size
                })
            });
        case 2:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5, {
                color: "thirdRankColor",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_3__/* .RiTrophyFill */ .e6w, {
                    fontSize: size
                })
            });
        case -1:
            return null;
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5, {
                color: "brandLinkColor",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_3__/* .RiStarFill */ .Kz, {
                    fontSize: size
                })
            });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (RankIcon);


/***/ }),

/***/ "./src/components/Landing/Leaderboard.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./node_modules/@chakra-ui/skeleton/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("./node_modules/@chakra-ui/media-query/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("./node_modules/@chakra-ui/tabs/dist/index.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _hooks_useENSData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/hooks/useENSData.ts");
/* harmony import */ var humanize_plus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/humanize-plus/dist/humanize.js");
/* harmony import */ var humanize_plus__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(humanize_plus__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Elements_Avatar_DisplayAvatar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/components/Elements/Avatar/DisplayAvatar.tsx");
/* harmony import */ var _Profile_CustomTab__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/components/Profile/CustomTab.tsx");
/* harmony import */ var _Elements_LinkElements_LinkOverlay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/components/Elements/LinkElements/LinkOverlay.tsx");
/* harmony import */ var _Elements_EditorRank_EditorRank__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/components/Elements/EditorRank/EditorRank.tsx");
/* harmony import */ var _Elements_Carousel_Carousel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/components/Elements/Carousel/Carousel.tsx");
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./node_modules/next-i18next/dist/esm/index.js");











const SECTIONS = [
    {
        period: "Day",
        disabled: true
    },
    {
        period: "Month",
        disabled: true
    },
    {
        period: "Year",
        disabled: true
    },
    {
        period: "All time",
        disabled: false
    }
];
const LeaderBoardCard = (param)=>{
    let { editor , index  } = param;
    const [, ensUserName] = (0,_hooks_useENSData__WEBPACK_IMPORTED_MODULE_2__/* .useENSData */ .L)(editor.id);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)("home");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .LinkBox */ .fG, {
        flex: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .chakra.div */ .m$.div, {
            p: 2,
            mx: "auto",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .kC, {
                alignSelf: "center",
                direction: "column",
                textAlign: "left",
                maxW: {
                    base: "min(90vw, 400px)",
                    md: "96",
                    lg: "388"
                },
                cursor: "pointer",
                mx: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Elements_LinkElements_LinkOverlay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    href: "/account/".concat(editor.id),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Elements_Avatar_DisplayAvatar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            alt: "user",
                            overflow: "hidden",
                            borderWidth: 2,
                            borderColor: "white",
                            rounded: "full",
                            justifySelf: "center",
                            size: 130,
                            address: editor.id,
                            wrapperProps: {
                                zIndex: "calc(var(--chakra-zIndices-sticky) - 1)"
                            },
                            svgProps: {
                                boxSize: "32",
                                overflow: "hidden",
                                borderWidth: 2,
                                borderColor: "white",
                                rounded: "full",
                                justifySelf: "center"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .VStack */ .gC, {
                            my: "6",
                            children: [
                                ensUserName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .xv, {
                                    fontSize: "md",
                                    textAlign: "center",
                                    color: "brandLinkColor",
                                    children: ensUserName
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Center */ .M5, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Skeleton */ .Od, {
                                        height: "14px",
                                        rounded: "lg",
                                        w: "130px"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .xv, {
                                    fontSize: "sm",
                                    textAlign: "center",
                                    children: [
                                        humanize_plus__WEBPACK_IMPORTED_MODULE_3__.intComma(editor.totalRewards),
                                        " ",
                                        t("iqEarned")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Elements_EditorRank_EditorRank__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            size: "30",
                            rank: index
                        })
                    ]
                })
            })
        })
    });
};
const LeaderBoard = (param)=>{
    let { leaderboards  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)("home");
    const tabPadding = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .useBreakpointValue */ .Sx)({
        base: "3",
        md: "5"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
        px: {
            base: 1,
            md: 8
        },
        pb: {
            base: 16,
            md: 20,
            lg: 24
        },
        textAlign: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Heading */ .X6, {
                textAlign: "center",
                mb: 4,
                fontWeight: "700",
                fontSize: {
                    base: "3xl",
                    lg: 46
                },
                children: t("leaderboard")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .xv, {
                color: "homeDescriptionColor",
                fontSize: {
                    base: "lg",
                    lg: 22
                },
                mx: "auto",
                mb: 9,
                px: 4,
                children: t("leaderboardDescription")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                maxW: "1160px",
                mx: "auto",
                overflowX: "hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .Tabs */ .mQ, {
                        defaultIndex: 3,
                        alignSelf: "self-start",
                        w: "full",
                        my: "6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .TabList */ .td, {
                            pl: 5,
                            border: "none",
                            children: SECTIONS.map((section, sid)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Profile_CustomTab__WEBPACK_IMPORTED_MODULE_5__/* .CustomTab */ .o, {
                                    _selected: {
                                        color: "brandLinkColor !important",
                                        _after: {
                                            background: "brandLinkColor !important"
                                        }
                                    },
                                    _disabled: {
                                        color: "thirdRankColor"
                                    },
                                    fontWeight: "semibold",
                                    p: tabPadding,
                                    children: t(section.period)
                                }, sid))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Elements_Carousel_Carousel__WEBPACK_IMPORTED_MODULE_8__/* .Carousel */ .l, {
                        topArrow: "25%",
                        settings: {
                            infinite: true,
                            speed: 500,
                            slidesToShow: 5,
                            slidesToScroll: 5,
                            responsive: [
                                {
                                    breakpoint: 1000,
                                    settings: {
                                        slidesToShow: 4,
                                        slidesToScroll: 4,
                                        initialSlide: 4,
                                        infinite: true
                                    }
                                },
                                {
                                    breakpoint: 680,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 2,
                                        infinite: true
                                    }
                                }
                            ]
                        },
                        children: leaderboards.map((editor, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeaderBoardCard, {
                                index: index,
                                editor: editor
                            }, "editor-".concat(index)))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LeaderBoard);


/***/ }),

/***/ "./src/components/Profile/CustomTab.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ CustomTab; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/tabs/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");



const CustomTab = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((props, ref)=>{
    const { noTab , p , ...rest } = props;
    const tabProps = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useTab */ .xD)({
        ...rest,
        ref
    });
    const isSelected = !!tabProps["aria-selected"];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra.button */ .m$.button, {
        display: "flex",
        alignItems: "center",
        _focus: {
            boxShadow: "none"
        },
        p: p || "5",
        cursor: "pointer",
        color: "fadedText2",
        pos: "relative",
        ...isSelected && {
            color: "black",
            _dark: {
                color: "white"
            },
            _after: {
                transition: "background-color 0.4s ease 0s",
                bg: "blue.400",
                bottom: 0,
                left: 0,
                content: "''",
                h: "2px",
                w: "full",
                pos: "absolute",
                borderTopRadius: "base"
            }
        },
        ...props,
        ...!noTab && tabProps,
        children: tabProps.children
    });
});


/***/ })

}]);